/**
 * Best-effort persona detection from the current SPA route.
 *
 * T203: the feedback widget tags each thread with the persona the user
 * was acting AS when they opened it. Server stores this as a soft
 * analytics hint, not a hard fact — we never gate behaviour on it.
 *
 * Detection is purely path-based here. Once we have richer per-user
 * persona claims (e.g. an umpire flag on the user model, T157), this
 * can be augmented to prefer the claim over the path.
 */

const ROUTE_RULES = [
  // Most-specific first.
  [/^\/cricket\/voice-analytics/, "scorer"],   // admin surface but voice context
  [/^\/cricket\/disputed-balls/, "scorer"],
  [/^\/cricket\/players?\//, "scorer"],
  [/^\/cricket\/matches?\/[^/]+\/score/, "scorer"],
  [/^\/cricket\/matches?\/[^/]+\/ball/, "scorer"],
  [/^\/cricket\/matches?\/[^/]+\/qc/, "scorer"],
  [/^\/cricket\/matches?\/[^/]+\/playing-xi/, "scorer"],
  [/^\/cricket\/matches?\/[^/]+\/squad/, "scorer"],
  [/^\/cricket\/matches?\/[^/]+\/toss/, "scorer"],
  [/^\/cricket\/matches?\/[^/]+\/scorecard/, "scorer"],
  [/^\/cricket\/matches?$/, "scorer"],

  [/^\/overlay\//, "broadcaster"],

  [/^\/admin/, "other"],
  [/^\/admin-portal/, "other"],

  [/^\/account\/topup/, "scorer"],
  [/^\/account\/subscriptions/, "scorer"],
  [/^\/account/, "scorer"],

  [/^\/contact-sales/, "other"],
  [/^\/pricing/, "other"],
  [/^\/help/, "scorer"],
  [/^\/dashboard/, "scorer"],
];


export function detectPersona(pathname) {
  const p = (pathname || (typeof window !== "undefined" ? window.location.pathname : "")) || "/";
  for (const [re, persona] of ROUTE_RULES) {
    if (re.test(p)) return persona;
  }
  return "other";
}
